import {DynTemporalField} from './dyn-temporal-field';
import {DynFieldData} from '../../../data/dyn-field-data';

export class DynDateField
    extends DynTemporalField {

    constructor() {
        super(null, 'date')
    }


    public getValue(data: DynFieldData): Date {
        return new Date(data.getValue());
    }

    public setValue(data: DynFieldData, value: Date) {
        data.setValue(value.getTime())
    }

    public getValueAsString(data: DynFieldData): string {
        return this.getValue(data).toLocaleString().split(' ')[0];
    }

    /*
    public static createFromObject(object: Object): DynDateField {
        const field = new DynDateField();
        field.updateFormObject(object);
        return field;
    }
*/

}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/temporal/dyn-date-field.ts